/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbles_viewer = {
    readonly isPinterestShareEnabled?: boolean | null;
    readonly isFacebookShareEnabled?: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubbleEmail_viewer">;
    readonly " $refType": "PdpRespIconBubbles_viewer";
};
export type PdpRespIconBubbles_viewer$data = PdpRespIconBubbles_viewer;
export type PdpRespIconBubbles_viewer$key = {
    readonly " $data"?: PdpRespIconBubbles_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubbles_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespIconBubbles_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchPdp",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "isPinterestShareEnabled",
          "name": "isEnabledByLocale",
          "args": [
            {
              "kind": "Literal",
              "name": "featureName",
              "value": "PINTEREST_SHARE"
            }
          ],
          "storageKey": "isEnabledByLocale(featureName:\"PINTEREST_SHARE\")"
        },
        {
          "kind": "ScalarField",
          "alias": "isFacebookShareEnabled",
          "name": "isEnabledByLocale",
          "args": [
            {
              "kind": "Literal",
              "name": "featureName",
              "value": "FACEBOOK_SHARE"
            }
          ],
          "storageKey": "isEnabledByLocale(featureName:\"FACEBOOK_SHARE\")"
        }
      ]
    }
  ]
};
(node as any).hash = 'cc296aff1fac53c63f40828ff8d7d8bc';
export default node;
